require('sass/blocks/iban/iban.scss');

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
import { formatText, FormattedText } from 'core/i18n';
const { ROBO, GBI, TRADITIONAL } = require('constants/userProfile');
import { isCountrySpain } from 'utilities/multiLanguageHelper';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import iconEnvelope from 'assets/icons/icon-envelope.svg';

const Iban = ({ userProfile, close }) => {
    const { name, iban, showIban, showIbanAtReload } = userProfile;
    let formatted_iban;

    if (iban) {
        formatted_iban = iban.split(' ').join('-');
    }

    const handleOnClose = () => {
        close && close();
    };

    let ibanAtReload;

    if (showIbanAtReload) {
        ibanAtReload = 'prospects-iban-marcos';
    }

    let classnames = classNames({
        'prospects-iban': true,
        'prospects-gutter': true,
        'prospects-iban-hide': !showIban,
        'prospects-iban-relaod': ibanAtReload,
    });

    let card = (
        <div>
            <h2 className="prospects-iban-title">
                <FormattedText value="iban-welcomeCostumer" injectedStrings={[name]} />
            </h2>
            <span className="dash"></span>
            <div className="prospects-iban-content">
                <ConditionalToggling condition={isCountrySpain() && userProfile.investmentType === TRADITIONAL}>
                    <p className="prospects-iban-content--follow-next">
                        <img className="iconenvelope" src={iconEnvelope} />
                        <FormattedText value="iban-followNextTraditional" /> <FormattedText value="iban-followNext" />
                    </p>
                </ConditionalToggling>
                <ConditionalToggling condition={!isCountrySpain()}>
                    <p className="prospects-iban-content--follow-next">
                        <img className="iconenvelope" src={iconEnvelope} />
                        <FormattedText value="iban-followNextPassport" />
                    </p>
                </ConditionalToggling>
            </div>
        </div>
    );

    if (userProfile.investmentType && (userProfile.investmentType === ROBO || userProfile.investmentType === GBI)) {
        card = (
            <div>
                <div className="prospects-iban-robo-title">
                    <FormattedText value="iban-welcomeRobo" />
                </div>
                <div className="prospects-iban-content">
                    <FormattedText value="iban-subTitleRobo" injectedStrings={[formatted_iban]} />
                    <p className="prospects-iban-content--follow-next">
                        <img className="iconenvelope" src={iconEnvelope} />
                        <FormattedText value="iban-followNextRobo" />
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className={classnames}>
            {card}
            <div className="prospects-iban-close-btn">
                <a
                    href="#"
                    onClick={event => {
                        event.preventDefault();
                        handleOnClose();
                    }}
                >
                    <span className="icons--icon-cancel"></span>
                </a>
            </div>
        </div>
    );
};

Iban.propTypes = {
    userProfile: PropTypes.shape({
        name: PropTypes.string,
        iban: PropTypes.string,
        showIban: PropTypes.bool,
        investmentType: PropTypes.string,
    }),
    close: PropTypes.func,
};

Iban.defaultProps = {
    close: null,
    userProfile: {
        name: '',
        iban: '',
        showIban: false,
        investmentType: '',
    },
};

module.exports.constructor = Iban;
module.exports = Iban;
